import toast from 'react-hot-toast';

export const handleApiError = (error) => {

  if (error.response && error.response.data) {
    const { erroTecnico, mensagem } = error.response.data;

    if (erroTecnico === 'PAYLOAD_INVALIDO') {
       return toast.error(`Dados Incompletos: Revise os campos do formulário antes de enviar.`, { duration: 5000 });
    }

    return toast.error(`Falha: ${mensagem || 'Ocorreu um erro no processamento.'}`);
  }

  if (error.request) {
    return toast.error("⚠️ Sem Conexão: Servidor indisponível ou fora do ar. Tente novamente mais tarde.", { duration: 6000 });
  }

  toast.error("Erro Inesperado: Falha interna no sistema.", { duration: 4000 });
};
